"use client";

import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

import { getEnabledGlobalLoadingSpinner } from "redux/selectors/header";

const Spinner = dynamic(() => import("components/Icons/Spinner"));

export const GlobalLoadingSpinner = () => {
  const enabled = useSelector(getEnabledGlobalLoadingSpinner);

  if (!enabled) {
    return null;
  }

  return (
    <div className="flex items-center inset-0 fixed justify-center opacity-100 z-50 bg-[rgba(246,246,246,0.75)]">
      <Spinner />
    </div>
  );
};
